import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FieldWrapper } from '@ngx-formly/core';
import { NgxTippyModule } from 'ngx-tippy-wrapper';

@Component({
  selector: 'app-formly-wrapper-tooltip',
  imports: [MatIconModule, MatTooltipModule, NgxTippyModule],
  templateUrl: './formly-wrapper-tooltip.component.html',
  styleUrl: './formly-wrapper-tooltip.component.scss',
})
export class FormlyWrapperTooltipComponent extends FieldWrapper {}
